export default "__VITE_ASSET__DlsQY5Af__"